import React from 'react'
import {ToFullSampleTypeName} from "../../utils/helpers";

export default function MainSection(props){
	return (
		<div className={"main-section"}>
			<h2>{props.title}</h2>
			<h3>{props.value}</h3>
			<div className={'dropdown-container'}>
				{props.children}
			</div>
		</div>
	)
}

MainSection.defaultProps = {
	title: 'NoTitle',
	value: 'NoValue'
}